import { useJsApiLoader } from "@react-google-maps/api";
import { GOOGLE_MAPS_API_KEY } from "../../../shared/consts/index";

/**
 * Singleton hook for loading Google Maps API
 * This ensures the API is only loaded once across the entire application
 */
export function useGoogleMapsLoader() {
  return useJsApiLoader({
    googleMapsApiKey: GOOGLE_MAPS_API_KEY,
    id: "__clock-location-map",
  });
}
